import { Controller } from "@hotwired/stimulus"
import ConsentService from "../../../javascript/services/consent_service"

export default class extends Controller {
  static targets = ["acceptButton", "rejectButton"]

  connect() {
  }

  accept(event) {
    event.preventDefault();
    ConsentService.updateConsent(true, (success) => {
      if (success) {
        this.element.style.display = "none";
      }
    });
  }

  reject(event) {
    event.preventDefault();
    ConsentService.updateConsent(false, (success) => {
      if (success) {
        this.element.style.display = "none";
      }
    });
  }
}